<template>
  <div v-if="loaded" class="container-fluid" id="calculatorWrap" v-bind:lang="lang">
    <div class="sidebar" >
      <header class="header px-4">
        <!-- <img class="logo" :src="regionData.logoImage" /> -->
        <h2>{{ regionData.textLabels.headingSmall }}</h2>
        <h1 class="mb-5-md">{{ regionData.textLabels.headingLarge }}</h1>
      </header>
    </div>

    <section class="side-results py-1 ml-0">
      <div class="result p-2">
        <p class="text">{{ regionData.textLabels.threeYearSavings }}</p>
        <p class="number mb-1">
          <sup class="currency">{{ regionData.units.currency }}</sup>{{threeYearSavings}}
        </p>
        <hr class="thin-line">
        <p class="text">
          <span>{{ regionData.textLabels.oneYear }}</span>
          <span class="mr-2 savings"> <sup class="currency">{{regionData.units.currency}}</sup>{{oneYearSavings}}</span>
          <span>{{ regionData.textLabels.oneMonth }}</span>
          <span class="savings"><sup class="currency">{{regionData.units.currency}}</sup>{{oneMonthSavings}}</span>
        </p>
      </div>
    </section>

    <section class="distance-weekday m-3">
      <div class="">
        <button @click="reset" class="btn-sm">
          <div><img src="static/reset.svg" class="icon"/><span class="text">{{regionData.textLabels.resetButtonText}}</span></div>
        </button>
        <h3 class="section-heading mt-3">{{ regionData.textLabels.distanceTravelledHeading }}</h3>
      </div>
      <div class="weekday-landscape">
        <h6 class="category">{{ regionData.textLabels.weekday }}</h6>
        <p v-animated-incrementing-numbers="{valToAnimateTo: userData.distanceTravelledWeekday, varName: 'distanceTravelledWeekday', timeInterval: 20, changeDiv: 20}" class="number">
          {{userData.distanceTravelledWeekday}}<sup class="unit"> {{ regionData.units.distance }}</sup>
        </p>
        <range-slider class="red mt-4 shorter-desktop"
          v-model:value="userData.distanceTravelledWeekday"
          v-bind:min="regionData.sliders.distanceTravelledWeekday.min"
          v-bind:max="regionData.sliders.distanceTravelledWeekday.max"></range-slider>
      </div>
    </section>

    <section class="distance-weekend m-3">
      <div class="weekend-landscape">
        <h6 class="category">{{ regionData.textLabels.weekend }}</h6>
        <p v-animated-incrementing-numbers="{valToAnimateTo: userData.distanceTravelledWeekend, varName: 'distanceTravelledWeekend', timeInterval: 25, changeDiv: 10}" class="number">
          {{userData.distanceTravelledWeekend}}<sup class="unit"> {{ regionData.units.distance  }}</sup>
        </p>
        <range-slider class="red mt-4"
          v-model:value="userData.distanceTravelledWeekend"
          v-bind:min="regionData.sliders.distanceTravelledWeekend.min"
          v-bind:max="regionData.sliders.distanceTravelledWeekend.max"></range-slider>
      </div>
    </section>

    <div class="main-current p-3 pt-4">
      <h3 class="section-heading">{{ regionData.textLabels.currentVehicleHeading }}</h3>
      <h6 class="category">{{ regionData.textLabels.currentVehicleFuelEconomy }}</h6>
      <p class="number">
        {{ userData.currentFuelEconomy | roundToTwo(regionData.sliders.currentVehicleFuelEconomy.stepSize) }}<sup class="unit">{{ regionData.units.fuelEconomy }} </sup>
      </p>
      <range-slider class="red mt-3"
        v-bind:step="regionData.sliders.currentVehicleFuelEconomy.stepSize"
        v-model:value="userData.currentFuelEconomy"
        v-bind:min="regionData.sliders.currentVehicleFuelEconomy.min"
        v-bind:max="regionData.sliders.currentVehicleFuelEconomy.max"></range-slider>
      <h6 class="category">{{ regionData.textLabels.currentVehicleFuelCost }}</h6>
      <p class="number">
        <sup class="currency">{{ regionData.units.currency }}</sup>{{ userData.currentFuelCost | roundToTwo(regionData.sliders.currentVehicleFuelCost.stepSize) }}<sup class="unit">/{{regionData.units.fuelVolume}}</sup>
      </p>
      <range-slider class="red mt-3"
        v-bind:step="regionData.sliders.currentVehicleFuelCost.stepSize"
        v-model:value="userData.currentFuelCost"
        v-bind:min="regionData.sliders.currentVehicleFuelCost.min"
        v-bind:max="regionData.sliders.currentVehicleFuelCost.max"></range-slider>
    </div>

    <div class="main-phev p-3 pt-4">
      <h3 class="section-heading">{{regionData.textLabels.phevVehicleHeading}}</h3>
      <div class="mb-4">
        <div class="">
          <h6 class="category">{{regionData.textLabels.phevFuelEconomy}}</h6>
          <p class="number">
            {{regionData.constants.phevFuelEconomy}}<sup class="unit">{{ regionData.units.evFuelEconomy ? regionData.units.evFuelEconomy : regionData.units.fuelEconomy }}</sup>
          </p>
        </div>
        <div class="">
          <h6 class="category">{{regionData.textLabels.phevElectricRange}}</h6>
          <p class="number">{{regionData.constants.phevElectricRange}}<sup class="unit">{{regionData.units.distance}}</sup></p>
        </div>
      </div>
      <div class="row ">
        <div class="mt-3">
          <h6 class="category">{{regionData.textLabels.phevFuelCost}}</h6>
          <p class="number">
            <sup class="currency">{{ regionData.units.currency }}</sup>{{userData.phevPetrolCost | roundToTwo(regionData.sliders.phevPetrolCost.stepSize)}}<sup class="unit">/{{regionData.units.fuelVolume}}</sup>
          </p>
          <range-slider class="mediumGrey red mt-3"
            v-bind:step="regionData.sliders.phevPetrolCost.stepSize"
            v-model:value="userData.phevPetrolCost"
            v-bind:min="regionData.sliders.phevPetrolCost.min"
            v-bind:max="regionData.sliders.phevPetrolCost.max"></range-slider>
        </div>
        <div class="">
          <h6 class="category">{{regionData.textLabels.phevElectricityCost}}</h6>
          <p class="number">
            <sup class="currency">{{regionData.units.currency}}</sup>{{userData.phevElectricityCost | roundToTwo(regionData.sliders.phevElectricityCost.stepSize)}}<sup class="unit">/{{regionData.units.electricity}}</sup>
          </p>
          <range-slider class="mediumGrey red mt-3"
            v-bind:step="regionData.sliders.phevElectricityCost.stepSize"
            v-model:value="userData.phevElectricityCost"
            v-bind:min="regionData.sliders.phevElectricityCost.min"
            v-bind:max="regionData.sliders.phevElectricityCost.max"></range-slider>
        </div>
      </div>
    </div>

    <div class="footer-btn p-3" v-if="regionData.textLabels.bookATestDriveText!=='' && regionData.countryName && regionData.countryName.toLowerCase() === 'canada'">
      <button data-event="test-drive" @click="goToTestDrive" class="critical">{{ regionData.textLabels.bookATestDriveText }}</button>
    </div>
    <div class="footer-disclaimer disclaimer p-3" v-if="regionData.textLabels.disclaimer!==''">
      <p v-html="regionData.textLabels.disclaimer"></p>
    </div>
  </div>
</template>

<script>
  import RangeSlider from 'vue-range-slider';
  import animatedIncrementingNumbers from "../directives/animatedIncrementingNumbers";
  // import 'vue-range-slider/dist/vue-range-slider.css';

  export default {
    name: 'MainComponent',
    watch: {
      'userData.phevPetrolCost': function (){
        this.userDataChanged('phevPetrolCost', this.regionData.units.currency + '/' + this.regionData.units.fuelVolume);
      },
      'userData.phevElectricityCost': function (){
        this.userDataChanged('phevElectricityCost', this.regionData.units.currency + '/' + this.regionData.units.electricity);
      },
      'userData.currentFuelCost': function (){
        this.userDataChanged('currentFuelCost', this.regionData.units.currency + '/' + this.regionData.units.fuelVolume);
      },
      'userData.currentFuelEconomy': function (){
        this.userDataChanged('currentFuelEconomy', this.regionData.units.fuelEconomy);
      },
      'userData.distanceTravelledWeekday': function () {
        if (this.animationComplete) {
          this.userDataChanged('distanceTravelledWeekday', this.regionData.units.distance);
        }
      },
      'userData.distanceTravelledWeekend': function () {
        if (this.animationComplete) {
          this.userDataChanged('distanceTravelledWeekend', this.regionData.units.distance);
        }
      }
    },
    filters: {
      roundToTwo: function (value, stepSize) {
        if (stepSize !== undefined) {
          if (stepSize % 1 !== 0) {
            return value.toFixed(2);
          }
          else {
            return value;
          }
        }
        return value.toFixed(2);
      }
    },
    directives: {
      animatedIncrementingNumbers: animatedIncrementingNumbers
    },
    components: {
      RangeSlider
    },
    computed: {
      animationComplete: function (){
        return this.animationsCompleted === this.totalAnimations;
      },
      oneWeekSavings: function () {
        // convert distances to MILES
        let distanceTravelledWeekday = this.userData.distanceTravelledWeekday;
        let distanceTravelledWeekend = this.userData.distanceTravelledWeekend;
        let phevElectricRange = this.regionData.constants.phevElectricRange;
        if (this.regionData.units.distance.toLowerCase() === "km"){
          distanceTravelledWeekday = this.convertKmToMiles(distanceTravelledWeekday);
          distanceTravelledWeekend = this.convertKmToMiles(distanceTravelledWeekend);
          phevElectricRange = this.convertKmToMiles(phevElectricRange);
        }
        // convert fuel economy to MPG
        let currentFuelEconomy = this.userData.currentFuelEconomy;
        let phevFuelEconomy = this.regionData.constants.phevFuelEconomy;
        if (this.regionData.units.fuelEconomy.toLowerCase() === "km/litre") {
          currentFuelEconomy = this.convertKmPLToMPG(currentFuelEconomy);
          phevFuelEconomy = this.convertKmPLToMPG(phevFuelEconomy);
        }
        else if (this.regionData.units.fuelEconomy.toLowerCase() !== "mpg") {
          currentFuelEconomy = this.convertLP100ToMPG(currentFuelEconomy);
          phevFuelEconomy = this.convertLP100ToMPG(phevFuelEconomy);
        }

        // convert fuel cost to /G
        let currentFuelCost = this.userData.currentFuelCost;
        let phevPetrolCost = this.userData.phevPetrolCost;
        if (this.regionData.units.fuelVolume.toLowerCase() === "l" || this.regionData.units.fuelVolume.toLowerCase() === "litre"){
          currentFuelCost = this.convertCostPLToPG(currentFuelCost);
          phevPetrolCost = this.convertCostPLToPG(phevPetrolCost);
        }
        // current cost
        let currentVehicleCostWeekday = (distanceTravelledWeekday / currentFuelEconomy) * currentFuelCost;
        let currentVehicleCostWeekend = (distanceTravelledWeekend / currentFuelEconomy) * currentFuelCost;
        let currentCostForWeek = currentVehicleCostWeekday * 5 + currentVehicleCostWeekend * 2;
        // phev electricity cost
        let phevElecDistanceWeekday = Math.min(distanceTravelledWeekday, phevElectricRange);
        let phevElecDistanceWeekend = Math.min(distanceTravelledWeekend, phevElectricRange);
        let phevElecCostForWeek = this.regionData.constants.phevElectricEconomy * this.userData.phevElectricityCost * (phevElecDistanceWeekday * 5 + phevElecDistanceWeekend * 2);
        // phev petrol cost
        let phevPetrolCostForWeek = 0;
        if (distanceTravelledWeekday > phevElectricRange){
          phevPetrolCostForWeek += (distanceTravelledWeekday - phevElectricRange) / phevFuelEconomy * phevPetrolCost * 5;
        }
        if (distanceTravelledWeekend > phevElectricRange){
          phevPetrolCostForWeek += (distanceTravelledWeekend - phevElectricRange) / phevFuelEconomy * phevPetrolCost * 2;
        }
        let phevTotalCostForWeek = phevPetrolCostForWeek + phevElecCostForWeek;
        return Math.max(currentCostForWeek - phevTotalCostForWeek, 0);
      },
      oneMonthSavings: function () {
        return Math.round(this.oneWeekSavings * 52 / 12);
      },
      oneYearSavings: function () {
        return Math.round(this.oneMonthSavings * 12);
      },
      threeYearSavings: function () {
        return Math.round(this.oneYearSavings * 3);
      }
    },
    methods: {
      debounce (func, wait, immediate) {
        // test
        var timeout;
        return function () {
          let context = this;
          let args = arguments;
          var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      },
      convertKmToMiles (distanceInKm) {
        return distanceInKm * this.KM_TO_MILE_MULT;
      },
      convertLP100ToMPG (economyInLP100) {
        // imperial gallon
        return this.LP100_TO_MPG_MULT / economyInLP100;
      },
      convertCostPLToPG (costPL) {
        return costPL / this.LITRE_TO_GALLON_MULT;
      },
      convertKmPLToMPG (kmPL) {
        return kmPL * this.KM_PER_LITRE_TO_MPG_MULT;
      },
      loadDoc: function () {
        let params = {};
        let defaultRegion = 'GB';
        let region = '';
        let defaultLang = 'en';
        let lang = '';
        let year = '';

        // Parse params from string
        let query = window.location.search;
        query = query.replace('?', '');
        let vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
          let pair = vars[i].split('=');
          params[pair[0]] = decodeURIComponent(pair[1]);
        }

        if (query !== '' && params.lang && params.region) {
          region = params.region;
          lang = params.lang;
          if (params.year != null && params.year !== '') {
            year = params.year;
          }
        }
        else {
          region = defaultRegion;
          lang = defaultLang;
        }

        this.lang = lang;
        const yearSegment = year ? `/${year}` : "";
        let loadPath = "./static/" + region.toLowerCase() + yearSegment + "/data_" + lang.toLocaleLowerCase() + ".json";
        var xhttp = new XMLHttpRequest();
        let self = this;

        xhttp.onreadystatechange = function () {
          if (this.readyState === 4 && this.status === 200) {
            self.regionData = JSON.parse(this.responseText);
            self.loaded = true;
            self.reset();
          }
          if (this.readyState === 4 && this.status >= 400) {
            self.loadDefaultDoc(defaultRegion, defaultLang);
          }
        };

        xhttp.open("GET", loadPath, true);
        xhttp.send();
      },
      loadDefaultDoc: function (region, lang) {
        let loadPath = "./static/" + region.toLowerCase() + "/data_" + lang.toLocaleLowerCase() + ".json";
        var xhttp = new XMLHttpRequest();
        let self = this;

        xhttp.onreadystatechange = function () {
          if (this.readyState === 4 && this.status === 200) {
            self.regionData = JSON.parse(this.responseText);
            self.loaded = true;
            self.reset();
          }
        };

        xhttp.open("GET", loadPath, true);
        xhttp.send();
      },
      goToTestDrive () {
        window.open(this.regionData.textLabels.bookATestDriveUrl, '_blank');
      },
      reset () {
        this.userData = this.getInitialUserData();
      },

      getInitialUserData () {
        return {
          currentFuelEconomy: this.regionData.sliders.currentVehicleFuelEconomy.default,
          distanceTravelledWeekday: this.regionData.sliders.distanceTravelledWeekday.default,
          distanceTravelledWeekend: this.regionData.sliders.distanceTravelledWeekend.default,
          currentFuelCost: this.regionData.sliders.currentVehicleFuelCost.default,
          phevPetrolCost: this.regionData.sliders.phevPetrolCost.default,
          phevElectricityCost: this.regionData.sliders.phevElectricityCost.default
        };
      },

      onScroll (e) {
        var scrollTop = 0;
        if (document.scrollingElement) {
          scrollTop = document.scrollingElement.scrollTop;
        }
        else {
          // IE
          scrollTop = (document.documentElement && document.documentElement.scrollTop) ||
            document.body.scrollTop;
        }
        if (scrollTop > this.SCROLL_BEFORE_FIXING && !this.$el.classList.contains(this.FIX_HEADER_CLASS)){
          this.$el.classList.add(this.FIX_HEADER_CLASS);
        }
        else if (scrollTop <= this.SCROLL_BEFORE_FIXING && this.$el.classList.contains(this.FIX_HEADER_CLASS)){
          this.$el.classList.remove(this.FIX_HEADER_CLASS);
        }
      }
    },
    mounted: function () {
      this.loadDoc();

      if (!window.dataLayer) {
        window.dataLayer = [];
      }

      this.userDataChanged = this.debounce(function (val, unit) {
        if (this.animationsCompleted) {
          window.dataLayer.push({
            "event": "sliderInteraction",
            "sliderType": val,
            "sliderValue": this.userData[val],
            "sliderUnit": unit,
            "threeYearSavings": this.threeYearSavings,
            "threeYearSavingsUnit": this.regionData.units.currency
          });
        }
      }, 250).bind(this);

      window.document.body.onscroll = this.onScroll;
    },
    beforeDestroy () {
      window.document.removeEventListener('scroll', this.onScroll);
    },
    data () {
      return {
        loaded: false,
        lang: 'en',
        regionData: {},
        // constants
        // UNIT_DISTANCE: "miles",
        GALLON_TO_LITRE_MULT: 4.54609,
        KM_TO_MILE_MULT: 1.0 / 1.60934,
        LP100_TO_MPG_MULT: 282.48,
        LITRE_TO_GALLON_MULT: 0.219969,
        KM_PER_LITRE_TO_MPG_MULT: 2.8248094,
        SCROLL_BEFORE_FIXING: 215,
        FIX_HEADER_CLASS: 'fix-header',

        userData: {},
        totalAnimations: 2,
        animationsCompleted: 0
      };
    }
  };
</script>

<style src="./_slider.css"></style>
<style src="./_main.css"></style>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/MainComponent.vue